import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/report/generator/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/report/generator/';

class ReportGeneratorService {
  generatePlayerGBEReportDocx(playerId, clientId) {
    return axios.get(API_URL  + "player-gbe/player/ " + playerId + "/client/" + clientId + "/docx", {
      responseType: 'blob',
    });
  }

  getPlayerGBEReportXls(playerId) {
    return axios.get(API_URL  + "player-gbe/player/" + playerId + "/xlsx",{
        responseType: 'blob',
    });
  }

  generatePlayersCollectionsXlsx(playersSelectedIds, collectionId) {
    return axios.post(API_URL  + "players/collection/" + collectionId + "/xlsx", playersSelectedIds, {
        responseType: 'blob',
    });
  }
}

export default new ReportGeneratorService();



// WEBPACK FOOTER //
// ./src/services/reportGenerator.service.js